<template>
  <div>
    <my-tab :tab="tab" :active="active" @tab="reTab"></my-tab>
    <div id="mylist" style="top: 100px">
      <div id="dasdlw" v-show="now == 1"></div>
      <Table v-show="now == 2" :columns="columns" :data="tableData"></Table>
    </div>
  </div>
</template>
<script>
import echarts from "echarts";
import axios from "axios";
export default {
  data() {
    return {
      tab: [
        { title: "图表", mark: 1 },
        { title: "表格", mark: 2 },
      ],
      active: 0,
      now: 1,
      columns: [
        {
          title: "月份",
          key: "month",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "总支出/元",
          key: "totalCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "当月平均/元",
          key: "averageCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "当月最高/元",
          key: "maxCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "当月最低/元",
          key: "minCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "日常费用/元",
          key: "otherCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "加油费用/元",
          key: "refuelCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "违章费用/元",
          key: "violationCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "维修费用/元",
          key: "repairCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
        {
          title: "保养费用/元",
          key: "careCost",
          minWidth: 80,
          maxWidth: 200,
          tooltip: true,
        },
      ],
      tableData: [],
      myData:[[]]
    };
  },
  methods: {
    getData() {
      let params = {
        carIdList: this.carIdList,
        //pageNumber: this.pageNumber,
        //pageSize: this.pageSize,
      };
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.serverWeb + "/ansCost/year",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.myData = [
          [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月",
          ],
        ];
        this.tableData = res.data.data;
        var obj = [
          {
            name: "维修",
            type: "bar",
            stack: "数据分析",
            color: ["#8db3ff"],
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "保养",
            type: "bar",
            stack: "数据分析",
            color: ["#c492f8"],
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "日常",
            type: "bar",
            stack: "数据分析",
            color: ["#ff8dd3"],
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "加油",
            type: "bar",
            stack: "数据分析",
            color: ["#fab296"],
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
          {
            name: "违章",
            type: "bar",
            stack: "数据分析",
            color: ["#81e8ec"],
            data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          },
        ];
        for (const i in data) {
          obj[0].data[i] = data[i].repairCost;
          obj[1].data[i] = data[i].careCost;
          obj[2].data[i] = data[i].otherCost;
          obj[3].data[i] = data[i].refuelCost;
          obj[4].data[i] = data[i].violationCost;
        }
        this.myData.push(obj);
        this.drawBar();
      });
    },
    drawBar() {
      var that = this;
      this.chart = echarts.init(document.getElementById("dasdlw"));
      this.option = {
        backgroundColor: "",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // Use axis to trigger tooltip
            type: "shadow", // 'shadow' as default; can also be 'line' or 'shadow'
          },
        },
        legend: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "value",

        },
        yAxis: {
          type: "category",
          data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月"],
          inverse:true
        },
        series: this.myData[1]
      };
      this.chart.setOption(this.option);

      this.chart.resize();
    },
    reTab(v) {
      this.now = v.mark;
      if (this.now == 1) {
        setTimeout(() => {
          this.drawBar();
        }, 500);
      }
    },
  },
  mounted() {
    // this.drawBar()
  },
};
</script>
<style lang="">
#dasdlw {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/fenxi/feiyong/year.vue